define('models/MenuModel',['underscore','backbone','ObjectModel','LocalStorage','moment'],function (_,Backbone,ObjectModel,LocalStorage,moment) {
    //
    // Model Menu
    //

    var MenuModelPrototype = {

        name:'MenuModel',
        idAttribute:'id_menu',
        route:'apiMenuModel',

        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        getItems:function(){
            var menuModel = this,
                menuItemsCollection = menuModel.menuItemsCollection;
            if(!menuItemsCollection){
                menuItemsCollection = menuModel.menuItemsCollection = new Backbone.Collection();
                menuItemsCollection.model = MenuItemModel;
                _(this.get('items')).each(function(item){
                    menuItemsCollection.add(item);
                })
            }
            return menuItemsCollection;
        },

    };

    var MenuItemModel = Backbone.Model.extend({
        getUrl:function(){
            return this.get('url');
        },
        getTarget:function(){
            return this.get('target');
        },
        getLabel:function(){
            return this.get('label');
        },
        getHtmlLink:function(className){
            var model = this,
                target = model.getTarget(),
                attrs = '';
            className = className || '';
            if(target !== '_self'){
                className += ' ignore-routing';
                attrs = 'target='+target;
                attrs += ' rel="noopener"';
            }
            return '<a href="'+model.getUrl()+'" class="'+className+'" '+attrs+'>'
                +model.getLabel()+'</a>';
        }

    })

    var MenuModel = ObjectModel.extend(LocalStorage).extend(MenuModelPrototype);

    return MenuModel;
});
